import { ImgHTMLAttributes, useMemo } from 'react'
import { getPublicConfig } from '~/config.ts'

export interface BucketImageProps
  extends ImgHTMLAttributes<HTMLImageElement> {
  profileId: string
}

export function BucketImage({
  profileId,
  ...props
}: BucketImageProps) {
  const src: string = useMemo(() => {
    return props.src
      ? `${
          getPublicConfig().profileImagesBaseUrl
        }/${profileId}/images/${props.src}`
      : ''
  }, [profileId, props.src])
  return src ? (
    <img
      loading="lazy"
      crossOrigin="anonymous"
      {...props}
      alt={props.alt || props.src}
      src={src}
    />
  ) : null
}
